import { Button, ModalHeader, ModalBody, ModalFooter, Header, Modal, Box } from "@nef/core"

import useAuthContext from "../../../../hooks/useAuthContext"

const AuthTimeoutModal = (props: any) => {
  const { isModalOpen, setIsModalOpen } = props
  const { handleLogOutUser } = useAuthContext()

  const goToLogin = () => {
    setIsModalOpen(false)
    handleLogOutUser()
  }

  return (
    <>
      <Modal
        className="auth-timeout-modal"
        size="lg"
        closeOnOutsideClick={false}
        isOpen={isModalOpen}
        toggle={() => {
          setIsModalOpen(isModalOpen)
        }}
      >
        <ModalHeader title="Sesssion Expired" />
        <ModalBody>
          <Box padding={6} margin="auto">
            <Header size={2}>Your session has expired due to inactivity. Return to Login.</Header>
          </Box>
        </ModalBody>
        <ModalFooter className="modal-footer">
          <Button
            onClick={() => {
              goToLogin()
            }}
          >
            Ok
          </Button>
        </ModalFooter>
      </Modal>
    </>
  )
}

export default AuthTimeoutModal
